<template>
  <v-container class="home" style="padding-top:0px">
    <v-row>
      <v-col col="1" md="1" sm="1">
        <GoBack/>
      </v-col>
      <v-col col="11" md="11" sm="11">
        <h1 class="text-white">{{ $t('cart.title') }}</h1>
        <span class="text-white" v-if="noItemInCart">{{ $t('cart.noitem') }}</span>
      </v-col>
    </v-row>
    <!-- <h3 v-for="(item, index) in cart" :key="item.orderid">{{ item.orderid }}</h3> -->

    <v-content style="padding-top:0">
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-card v-if="cart.length>0">
            <v-card-title>
              <span class="mr-2" style="font-weight:normal">{{ $t('cart.total') }}:</span>
              {{ (total.toFixed(0) * 1).toLocaleString() }} $
              <!-- <v-btn @click="saveXLSCustom" class="ma-2 right" color="primary">
                  <v-icon left>mdi-download</v-icon>CUSTOM XLSX
              </v-btn>-->

              <v-spacer></v-spacer>

              <form id="xlsxform" v-bind:action="$XLSX_URL+'?token='+token" method="POST">
                <input
                  type="hidden"
                  id="xlsxReportData"
                  v-model="xlsxReportData"
                  value="test"
                  name="content"
                >

  <v-btn @click="saveXLS" class="ma-2 right" color="primary">
                  <v-icon left>mdi-download</v-icon>{{ $t('cart.create_proforma_invoice')}}
                </v-btn>

                <v-btn @click="savePDF" class="ma-2 right" color="primary">
                  <v-icon left>mdi-download</v-icon>PDF
                </v-btn>

              
              </form>

              <form id="pdfform" v-bind:action="$CARTPDF_URL+'?token='+token" method="POST">
                <input type="hidden" id="cartData" v-model="cartData" value="test" name="content">
                <!-- <input type="hidden" v-model="reportName" value="test" name="content"> -->
              </form>

              <!-- <v-text-field
                v-model="search"
                append-icon="search"
                :label="$t('search')"
                single-line
                hide-details
              ></v-text-field>-->
            </v-card-title>

            <v-data-table
              :no-data-text="$t('result_no_data_text')"
              multi-sort
              item-key="idid"
              :headers="headers"
              :items="cart"
            >
                <template v-slot:item.order_count="{ item }">
                <!-- <v-btn @click="addItemToCart(item)" text icon color="primary">
                  <v-icon>mdi-plus</v-icon>
                </v-btn> -->

                <!-- @change="updateOrderCount(item)" -->
                <v-text-field

                @input="itemOrderCountChanged(item)"
                v-model="item.order_count"

            :append-outer-icon="'mdi-minus'"
            :prepend-icon="'mdi-plus'"
            type="number"
            @click:append-outer="
            
                 if(item.order_count > 1){
                   minusItemToCart(item)
                  } else {
                    confirmForDelete(item)
                  }
                  
            "
            @click:prepend="addItemToCart(item)"
                ></v-text-field>

                <!-- <v-text-field style="width:50px;"
                @change="itemOrderCountChanged(item)" 
                v-model="item.order_count" 
                ></v-text-field>-->

                <!-- <span
                  @click="getOrderCountFromUserInput(item)"
                  style="font-size:1.2em; cursor:pointer"
                > -->
                  <!-- {{ item.order_count }} -->

                  <!-- <span>
                    <v-text-field

                      style="width:50px;"
                      @input="itemOrderCountChanged(item)"
                      v-model="item.order_count"
                    ></v-text-field>
                  </span> -->
                <!-- </span> -->

                <!-- <v-btn
                  @click="
                 if(item.order_count > 1){
                   minusItemToCart(item)
                  } else {
                    confirmForDelete(item)
                  }
                  
                  "
                  text
                  icon
                  color="primary"
                >
                  <v-icon>mdi-minus</v-icon>
                </v-btn> -->
              </template>

              <template v-slot:item.pump_type="{ item }">
                <!-- <a @click="gotoReport(item.url)"> -->
                {{ item.pump_type +" / "+item.stage }}
                <!-- </a> -->
              </template>


              

              <template v-slot:item.fi_e="{ item }">{{ item.fi_e +"\"" }}</template>

              <template
                v-slot:item.total_price="{ item }"
              >{{ ((item.total_price * item.order_count).toFixed(1) * 1 ).toLocaleString() }}</template>

              <template
                v-slot:item.motor_price="{ item }"
              >{{ ((item.motor_price * 1).toFixed(0) * 1).toLocaleString() }}</template>

              <template
                v-slot:item.pump_price="{ item }"
              >{{ ((item.pump_price * 1).toFixed(0) * 1 ).toLocaleString() }}</template>

              <template
                v-slot:item.motor_type="{ item }"
              >{{ item.motor_type +" "+item.motor_power + " HP" }}</template>

              <!-- <template @click="/test/" v-slot:item.model="{ item }">
              <a @click="showReport(item)">{{ item.model }}</a>
            </template>
              -->
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="ml-1 mr-1">
        <!-- <v-btn text @click="back">{{ $t('cart.go_back') }}</v-btn> -->
        <v-spacer></v-spacer>
        <v-btn v-if="cart.length" color="secondary" @click="emptyChart">{{ $t('cart.empty_cart') }}</v-btn>
      </v-row>
    </v-content>
  </v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import GoBack from "@/components/GoBack.vue";
import { cart_report } from "./cart-report.js";
import { checkLogin, handleServerError } from "../components/utils.js";

export default {
  name: "cart",

  data: () => ({
    noItemInCart: false,
    token: "",
    showTable: false,
    selected: [],
    cart: [],
    cartData: "",
    xlsxReportData: ""
  }),
  computed: {
    total() {
      var total = 0.0;
      this.cart.forEach(item => {
        total += parseFloat(item.total_price) * item.order_count;
      });
      return total;
    },
    headers() {
      return [
        {
          text: this.$t("pump.model"),
          align: "left",
          sortable: true,
          value: "pump_type",
          width: 120
        },
        {
          text: this.$t("pump.stage"),
          align: " d-none",
          sortable: true,
          value: "stage",
          visible: false,
          width: 120
        },
        { text: this.$t("pump.diameter") + " (mm)", value: "pump_diameter" },
        { text: this.$t("motor.power") + " (HP)", value: "motor_power" },
        { text: this.$t("motor.model"), value: "motor_type", width: 140 },
        { text: this.$t("motor.phase"), value: "phase" },
        { text: this.$t("motor.diameter") + " (mm)", value: "motor_diameter" },
        { text: this.$t("pump.material"), value: "material" },
        { text: this.$t("pump.outlet_diameter") + ' (")', value: "fi_e" },
        { text: this.$t("pump.price") + " ($)", value: "pump_price" },
        { text: this.$t("motor.price") + " ($)", value: "motor_price" },
        {
          text: this.$t("cart.order_count"),
          align: "left",
          sortable: false,
          value: "order_count",
          width: 165
        },
        {
          align: "right",
          text: this.$t("total_price") + " ($)",
          value: "total_price"
        }
      ];
    }
  },
  components: {
    GoBack
  },
  mounted: function() {
    if (localStorage.token) {
      this.token = localStorage.token;
      this.$http.defaults.headers.common["Authorization"] = `Bearer ${
        this.token
      }`;
    } else {
      this.$router.push("/");
    }
    // this.initLocalStorageCart();
    this.getCart();
  },
  methods: {
    itemOrderCountChanged: function(item) {
      if ( parseInt(item.order_count) > -1){
      console.log(item.order_count);

        this.updateOrderCount(item, item.order_count)
      }
    },
    getOrderCountFromUserInput: function(item) {
      const newCount = prompt(
        this.$t("cart.enter_order_count") + ":",
        item.order_count
      );
      this.updateOrderCount(item, newCount);
    },

    addItemToCart: function(item) {
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "save_cart_item",
        data: item
      })
        .then(response => {
          // checkLogin(response, this.token)
          console.log(response.data);
          this.getCart();
        })
        .catch(function(error) {
          // alert(error);
          handleServerError(error);
          console.log(error);
        });
    },
    emptyChart: function() {
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "empty_cart"
      })
        .then(response => {
          // checkLogin(response, this.token)
          // console.log(response.data)
          this.getCart();
        })
        .catch(function(error) {
          // alert(error);
          handleServerError(error);
          console.log(error);
        });
    },
    minusItemToCart: function(item) {
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "minus_cart_item",
        data: item
      })
        .then(response => {
          // checkLogin(response, this.token)
          console.log(response.data);
          this.getCart();
        })
        .catch(function(error) {
          // alert(error);
          handleServerError(error);
          console.log(error);
        });
    },

    updateOrderCount: function(item, newCount) {
      // console.log("item.order_count is " + item.order_count +" update to "+ newCount)
      var itemCloned = { ...item };
      itemCloned.order_count = newCount;
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "update_cart_item_order_count",
        data: itemCloned
      })
        .then(response => {
          // checkLogin(response, this.token)
          console.log(response.data);
          this.getCart();
        })
        .catch(function(error) {
          // alert(error);
          handleServerError(error);
          console.log(error);
        });
    },
    getCart: function() {
      this.$http
        .get(this.$API_URL + "cart")
        .then(result => {
          // checkLogin(result, this.token)
          this.cart = result.data;
          if (this.cart.length <= 0) this.noItemInCart = true;
        })
        .catch(function(error) {
          // alert(error);
          handleServerError(error);
          console.log(error);
        });
    },
    confirmForDelete: function(item) {
      confirm(this.$t("cart.confirm_delete")) && this.minusItemToCart(item);
    },
 
    savePDF: function(event) {
      // const cartLayout = ""
      // this.reportLayoutInput = "dd = " + JSON.stringify(cartLayout);
      
      const currentLang = this.$i18n.locale;

      if ( currentLang == 'ar'){
        this.$i18n.locale = 'en'
        setTimeout(() => {  
        // console.log('locale')
        // console.log(this.$i18n.locale)
        this._savePDF()
        this.$i18n.locale = currentLang
       }, 1000);
       return
      } 

      this._savePDF()
      
      
      
    },
    _savePDF: function() {
        document.getElementById("cartData").value =
                "dd = " +
                JSON.stringify(
                  cart_report(this.cart, this.headers, this.$t("cart.title"))
                );
              document.getElementById("pdfform").submit();
    },

    saveXLS: function(event) {
      const currentCart = [...this.cart];
      currentCart.push(this.headers);
      document.getElementById("xlsxReportData").value =
        "dd = " + JSON.stringify(currentCart);

      document.getElementById("xlsxform").submit();
    },
    saveXLSCustom: function(event) {
      const currentCart = [...this.cart];
      currentCart.push(this.headers);
      document.getElementById("xlsxReportData").value =
        "dd = " + JSON.stringify(currentCart);

      document.getElementById("xlsxform").submit();
    },

    gotoReport: function(url) {
      console.log("url is : " + url);
      this.$router.push(url);
    },
    back: function() {
      window.history.back();
    },

    initLocalStorageCart: function() {
      let callback = (val, oldVal, uri) => {
        // console.log("localStorage change, Cart: ", val);

        try {
          this.cart = JSON.parse(val);
        } catch (e) {
          this.cart = [];
        }
      };

      this.$ls.on("cart", callback);

      try {
        this.cart = JSON.parse(this.$ls.get("cart", []));
        this.$ls.on("cart", callback);
      } catch (e) {
        this.cart = [];
        this.$ls.on("cart", callback);
      }
    },

    saveOrders: function() {
      const parsed = JSON.stringify(this.cart);
      this.$ls.set("cart", parsed, 12 * 60 * 60 * 1000);
      console.log("saved");
    },

    queryPumps: function() {
      console.log(this.query);
      this.pumps = [];

      let query_copy = Object.assign({}, this.query);

      if (query_copy.unit_flow == "gpm") this.flow_carpan = 0.2271;
      else if (query_copy.unit_flow == "l_sec") this.flow_carpan = 3.6;
      else if (query_copy.unit_flow == "l_min") this.flow_carpan = 0.06;
      else this.flow_carpan = 1.0;

      query_copy.flow = query_copy.flow * this.flow_carpan;

      if (query_copy.unit_hm == "ft") this.head_carpan = 0.3048;
      else this.head_carpan = 1.0;

      query_copy.hm = query_copy.hm * this.head_carpan;

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "query_pumps",
        data: query_copy
      })
        .then(response => {
          // checkLogin(response, this.token)
          var flowUnitString = "";
          //  var headUnitString = "";

          this.units.flow.forEach(element => {
            if (query_copy.unit_flow == element.value)
              flowUnitString = element.text2;
          });

          this.headers[2].text = "Flow (" + flowUnitString + ")";

          this.headers[3].text = "Head (" + query_copy.unit_hm + ")";

          this.pumps = response.data;

          this.showTable = true;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
